// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gnE_","top":"styles_top__DPdgZ"};